var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H1.42857C0.639286 0 0 0.639286 0 1.42857V18.5714C0 19.3607 0.639286 20 1.42857 20H10C10.7893 20 11.4286 19.3607 11.4286 18.5714V1.42857C11.4286 0.639286 10.7893 0 10 0ZM5.71429 18.5714C5.32 18.5714 5 18.2514 5 17.8571C5 17.4629 5.32 17.1429 5.71429 17.1429C6.10857 17.1429 6.42857 17.4629 6.42857 17.8571C6.42857 18.2514 6.10857 18.5714 5.71429 18.5714ZM10 16.4286H1.42857V2.14286H10V16.4286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobile_phone.7cdb29bf70c5a7f9be3c7b3dcff8e381.svg";
export { ForwardRef as ReactComponent };